export enum LegStatusNames {
  NOTSTARTED = 'Not Started',
  ENROUTE = 'Enroute',
  ONSCENE = 'On-Scene',
  PICKEDUP = 'Picked up',
  DROPPEDOFF = 'Dropped Off',
  DRIVERDONE = 'Driver Done',
  JOBDONE = 'Job Done',
  ONBOARD = 'On-board',
  WHEELSUP = 'Wheels Up',
  LANDED = 'Landed',
}

export enum TransportType {
  GROUND = 'Ground',
  AIR = 'Air',
}

export interface IDistanceDuration {
  distance: string;
  duration: string;
}

export interface IAddListnerToInfowindowModle {
  infoWindowContent: string;
  isAddEventListner: boolean;
  function: any;
}
